import { strings } from '../../../lang';

const normalizeCustomerSource = (customerSource: string) =>
  customerSource.trim().toLocaleLowerCase('de-DE');

const CUSTOMER_PORTAL_TIP_EXCLUDED_SOURCES = new Set([
  'Stadtwerke Springe',
  'Rheinenergie',
].map(normalizeCustomerSource));

export const shouldShowPreSalesCustomerPortalTip = (customerSource?: string) =>
  !CUSTOMER_PORTAL_TIP_EXCLUDED_SOURCES.has(normalizeCustomerSource(customerSource ?? ''));

type PreSalesBookingTipsProps = {
  showCustomerPortal: boolean;
};

export const PreSalesCustomerPortalTip = () => (
  <aside className="bp-presales-booking-tip" role="note">
    <strong>{strings.preSalesQuestionnaire.customerPortalTipTitle}</strong>
    <p>{strings.preSalesQuestionnaire.customerPortalTipDescription}</p>
    <ul>
      {strings.preSalesQuestionnaire.customerPortalTipBenefits.map((benefit) => (
        <li key={benefit}>{benefit}</li>
      ))}
    </ul>
  </aside>
);

export const PreSalesBookingTips = ({
  showCustomerPortal,
}: PreSalesBookingTipsProps) => (
  <div className="bp-presales-booking-tips">
    <aside className="bp-presales-booking-tip" role="note">
      <strong>{strings.preSalesQuestionnaire.whatsAppTipTitle}</strong>
      <p>{strings.preSalesQuestionnaire.whatsAppTipDescription}</p>
    </aside>

    {showCustomerPortal && (
      <PreSalesCustomerPortalTip />
    )}
  </div>
);
